import { render, staticRenderFns } from "./Wix-integration.vue?vue&type=template&id=4405d916&"
import script from "./Wix-integration.vue?vue&type=script&lang=js&"
export * from "./Wix-integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports